@if (text || tooltipRef) {
  <main
    [class]="'tooltip-container ' + placement"
    [style.max-width.px]="maxWidth"
  >
    @if (text) {
      <span [innerHTML]="text"></span>
    }

    @if (tooltipRef) {
      <ng-container *ngTemplateOutlet="tooltipRef "/>
    }
  </main>
}
